import setupBootstrap from "./features/bootstrap-customization";
import "./features/font/brands";
import "./features/font/solid";
import "./features/font/fontawesome";
import setupSearch from "./features/search";
import setupNavigation from "./features/navigation";
import setupLogin from "./features/login/login.js";
import setupLoginRegister from "./features/login/login-register.js";
import setupEditUserProfile from "./features/private-seller/edit-user-profile/edit-user-profile.js";
import setupEditDealerProfile from "./features/dealer/edit-dealer-profile/edit-dealer-profile.js";
import setupSellBoat from "./features/private-seller/sell-boat/sell-boat.js";
import alertHelper from "./features/alert/alert.js"
import savedBoats from "./features/saved-boats";
import setupUserProfile from "./features/user-profile/user-main.js"
import setupSpincrement from "./features/jquery.spincrement.js";
import setupSwiper from "./features/swiper.js";
import setupFancybox from "./features/fancybox";
import setupSeachMenu from "./features/search-menu-home";
import setupModalWindow from "./features/modal-window";
import setupRemoveBoat from "./features/user-profile/remove-boat";
import sutupRichTextEdit from "./features/trumbowyg";
import lozad from 'lozad';
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

window.asyncReady(() => {
    setupLogin();
    setupBootstrap();
    setupSearch();
    setupNavigation();
    setupLoginRegister();
    // Check if URL contains 'private-seller' before setting up edit user profile
    if (window.location.href.includes('/private-seller/')) {
        setupUserProfile();
        setupEditUserProfile();
        setupSellBoat();
        setupRemoveBoat();
    }
    if (window.location.href.includes('/dealer/')) {
        setupUserProfile(); 
        setupEditDealerProfile();
        setupRemoveBoat();
    }
    setupSpincrement();
    savedBoats();
    setupSwiper();
    setupFancybox();
    setupSeachMenu();
    setupModalWindow();
    sutupRichTextEdit();
    //For Lazy loading of images
    const observer = lozad();
    observer.observe();
});
